<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Off-Grid Solar System</h2>

            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>
                <li>Solar Solutions</li>
                <li>Off-Grid Solar System</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="services-details-image wow animate__animated animate__fadeInUp">
                <img src="assets/image/solar2.png" alt="Off-Grid Solar System">
            </div>
            <div class="services-details-desc">
                <span>Off-Grid Solar Solutions</span>
                <h3>Reliable Solar Power Without Dependence on the Grid</h3>
                <p>
                    An off-grid solar system is a standalone solar power solution
                    that generates and stores electricity without depending on the
                    public electricity grid.
                </p>
                <p>
                    It is particularly useful for locations where grid electricity
                    is unavailable, unreliable, or affected by frequent power
                    interruptions. Solar energy generated during the day can be
                    stored in batteries and used when sunlight is unavailable.
                </p>
                <ul class="features-list">
                    <li>
                        <i class="bx bx-check-double"></i>
                        Independent Solar Power
                    </li>
                    <li>
                        <i class="bx bx-check-double"></i>
                        Battery Backup
                    </li>
                    <li>
                        <i class="bx bx-check-double"></i>
                        Customized System Design
                    </li>
                    <li>
                        <i class="bx bx-check-double"></i>
                        Reliable Energy Supply
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- What Is an Off-Grid Solar System? -->
<section class="features-area ptb-100 bg-f7f9fc">
    <div class="container">
        <div class="section-title">
            <span>Understanding Off-Grid Solar</span>
            <h2>What Is an Off-Grid Solar System?</h2>
            <p>
                A simple and independent way to generate, store, and use
                solar electricity without a direct connection to the utility grid.
            </p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <span class="card-number">01</span>
                    <h3>Generate Solar Power</h3>
                    <p>
                        Solar panels capture sunlight and convert it into
                        electricity that can be used to power connected loads.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-battery"></i>
                    </div>
                    <span class="card-number">02</span>
                    <h3>Store Excess Energy</h3>
                    <p>
                        Extra electricity generated during the day can be
                        stored in batteries for use when solar generation is low.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-bulb"></i>
                    </div>
                    <span class="card-number">03</span>
                    <h3>Use Power When Needed</h3>
                    <p>
                        Stored energy can supply your appliances during the
                        night or during periods of insufficient sunlight.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- System Components -->
<section class="solar-components-area ptb-100 bg-fafafa">
    <div class="container">

        <div class="section-title">
            <span>System Components</span>
            <h2>What Makes an Off-Grid Solar System?</h2>
            <p>
                Every component has an important role in generating, storing,
                managing, and safely delivering solar power.
            </p>
        </div>

        <div class="solar-components-list">

            <!-- 01 -->
            <div class="solar-component-item">
                <div class="component-number">
                    01
                </div>
                <div class="component-icon">
                    <i class="bx bx-sun"></i>
                </div>
                <div class="component-content">
                    <h3>Solar Panels</h3>
                    <p>
                        Convert sunlight into DC electricity for your
                        home, business, or other connected loads.
                    </p>
                </div>
            </div>

            <!-- 02 -->
            <div class="solar-component-item">
                <div class="component-number">
                    02
                </div>
                <div class="component-icon">
                    <i class="bx bx-transfer"></i>
                </div>
                <div class="component-content">
                    <h3>Solar Inverter</h3>
                    <p>
                        Converts and manages solar and battery power so
                        it can be used by electrical appliances.
                    </p>
                </div>
            </div>

            <!-- 03 -->
            <div class="solar-component-item">
                <div class="component-number">
                    03
                </div>
                <div class="component-icon">
                    <i class="bx bx-battery"></i>
                </div>
                <div class="component-content">
                    <h3>Battery Bank</h3>
                    <p>
                        Stores excess solar energy and makes it available
                        when solar generation is insufficient.
                    </p>
                </div>
            </div>

            <!-- 04 -->
            <div class="solar-component-item">
                <div class="component-number">
                    04
                </div>
                <div class="component-icon">
                    <i class="bx bx-slider"></i>
                </div>
                <div class="component-content">
                    <h3>Charge Controller</h3>

                    <p>
                        Helps regulate the charging of batteries from
                        electricity generated by the solar panels.
                    </p>
                </div>
            </div>

            <!-- 05 -->
            <div class="solar-component-item">
                <div class="component-number">
                    05
                </div>

                <div class="component-icon">
                    <i class="bx bx-layer"></i>
                </div>

                <div class="component-content">
                    <h3>Mounting Structure</h3>

                    <p>
                        Supports the solar panels and helps position them
                        for effective exposure to sunlight.
                    </p>
                </div>
            </div>

            <!-- 06 -->
            <div class="solar-component-item">
                <div class="component-number">
                    06
                </div>
                <div class="component-icon">
                    <i class="bx bx-shield-quarter"></i>
                </div>
                <div class="component-content">
                    <h3>Safety & Accessories</h3>

                    <p>
                        Cables, connectors, earthing, protection devices,
                        and other accessories help ensure safe operation.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Ideal Applications -->
<section class="features-area ptb-100">
    <div class="container">

        <div class="section-title">
            <span>Ideal Applications</span>

            <h2>Where Does Off-Grid Solar Make Sense?</h2>

            <p>
                Off-grid systems are particularly useful where dependable
                grid electricity is difficult to access or unavailable.
            </p>
        </div>

        <div class="row">

            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-home"></i>
                    </div>

                    <h3>Remote Homes</h3>

                    <p>
                        A practical option for homes located in areas
                        without dependable grid connectivity.
                    </p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-buildings"></i>
                    </div>

                    <h3>Remote Businesses</h3>

                    <p>
                        Helps businesses in remote locations meet their
                        electricity requirements independently.
                    </p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-leaf"></i>
                    </div>

                    <h3>Farms & Agriculture</h3>

                    <p>
                        Suitable for agricultural locations where reliable
                        electricity access may be limited.
                    </p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-bolt-circle"></i>
                    </div>
                    <h3>Power Cut Areas</h3>
                    <p>
                        Battery-backed solar can provide stored energy when
                        conventional grid power is unavailable.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Energy Storage -->
<section class="battery-storage-area ptb-100">
    <div class="container">
        <div class="battery-storage-box">
            <!-- Left Content -->
            <div class="battery-content">
                <span class="section-tag">
                    Energy Storage
                </span>
                <h2>
                    Battery Backup Is at the Heart of an Off-Grid System
                </h2>
                <p>
                    Since an off-grid system cannot rely on the utility grid,
                    battery storage plays an important role in maintaining
                    power when solar generation is unavailable.
                </p>
                <p>
                    The required battery capacity depends on your electricity
                    consumption, backup duration, load pattern, solar generation,
                    battery technology, and overall system design.
                </p>
                <a routerLink="/contact" class="btn btn-primary">
                    Discuss Your Energy Needs
                    <i class="flaticon-right"></i>
                </a>
            </div>


            <!-- Right Storage Features -->
            <div class="battery-features">
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-home"></i>
                    </div>
                    <div>
                        <h3>Backup Designed Around Your Load</h3>
                        <p>
                            Battery capacity is planned according to your
                            actual electricity requirements.
                        </p>
                    </div>
                </div>


                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <div>
                        <h3>Day & Night Energy Management</h3>
                        <p>
                            Store excess solar energy during the day and
                            use it when solar generation is unavailable.
                        </p>
                    </div>
                </div>
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-slider-alt"></i>
                    </div>
                    <div>
                        <h3>Customized Battery Capacity</h3>
                        <p>
                            Storage capacity can be selected based on
                            backup duration and energy consumption.
                        </p>
                    </div>
                </div>
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-bolt-circle"></i>
                    </div>
                    <div>
                        <h3>Reliable Stored Energy</h3>
                        <p>
                            Keep essential loads powered during periods
                            of low or unavailable solar generation.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Why Choose Off-Grid Solar -->
<section class="services-area ptb-100 bg-fafafa">
    <div class="container">

        <div class="section-title">
            <span>Why Choose Off-Grid Solar?</span>

            <h2>Key Benefits of Going Off-Grid</h2>

            <p>
                Get greater control over your energy with a solar system
                designed around your own electricity requirements.
            </p>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-power-off"></i>
                    </div>

                    <h3>Energy Independence</h3>

                    <p>
                        Generate and store your own electricity without
                        depending entirely on the public electricity grid.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-battery"></i>
                    </div>

                    <h3>Battery Backup</h3>

                    <p>
                        Stored solar energy can provide power when solar
                        generation is low or unavailable.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-leaf"></i>
                    </div>

                    <h3>Clean Energy</h3>

                    <p>
                        Use a renewable source of energy and reduce your
                        dependence on conventional electricity generation.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-map"></i>
                    </div>

                    <h3>Remote Power</h3>

                    <p>
                        Bring dependable electricity to locations where
                        conventional grid access is difficult.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-cog"></i>
                    </div>

                    <h3>Customized Design</h3>

                    <p>
                        System capacity and battery storage can be planned
                        according to your actual energy requirements.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-sun"></i>
                    </div>

                    <h3>Renewable Power</h3>

                    <p>
                        Generate electricity from sunlight and move towards
                        a cleaner and more sustainable energy solution.
                    </p>
                </div>
            </div>

        </div>

    </div>
</section>

<section class="solar-process-area ptb-100 bg-f7f9fc">
    <div class="container">

        <div class="section-title">
            <span>Our Process</span>

            <h2>From Requirement to Reliable Solar Power</h2>

            <p>
                <strong>SolarCiti</strong> follows a structured approach to understand your
                energy needs, design the right system, and deliver dependable
                solar power.
            </p>
        </div>

        <div class="solar-process">

            <!-- Step 01 -->
            <div class="process-step">

                <div class="process-top">
                    <span>01</span>
                    <i class="bx bx-map-pin"></i>
                </div>

                <div class="process-content">
                    <h3>Site Assessment</h3>

                    <p>
                        We understand your location, available space,
                        electricity usage, and energy requirements.
                    </p>
                </div>

            </div>


            <!-- Step 02 -->
            <div class="process-step">

                <div class="process-top">
                    <span>02</span>
                    <i class="bx bx-ruler"></i>
                </div>

                <div class="process-content">
                    <h3>System Sizing</h3>

                    <p>
                        Solar generation, inverter capacity, and battery
                        storage are planned around your requirements.
                    </p>
                </div>

            </div>


            <!-- Step 03 -->
            <div class="process-step">

                <div class="process-top">
                    <span>03</span>
                    <i class="bx bx-cog"></i>
                </div>

                <div class="process-content">
                    <h3>Installation</h3>

                    <p>
                        The selected solar equipment is installed and
                        configured for safe and efficient operation.
                    </p>
                </div>

            </div>


            <!-- Step 04 -->
            <div class="process-step">

                <div class="process-top">
                    <span>04</span>
                    <i class="bx bx-support"></i>
                </div>

                <div class="process-content">
                    <h3>Support</h3>

                    <p>
                        We provide post-installation support and maintenance
                        to help keep your solar system performing efficiently.
                    </p>
                </div>

            </div>

        </div>

    </div>
</section>

<!-- Start Services Details Area -->
<section class="services-details-area">
    <div class="container">
        <!-- Off Grid vs On Grid -->
        <div class="services-details-comparison ptb-100">
            <div class="section-title">
                <span>Solar System Comparison</span>

                <h2>Off-Grid vs On-Grid Solar System</h2>
                <p>
                    Off-grid solar provides greater energy independence by
                    generating and storing electricity without relying on
                    the public electricity grid. Compare it with an on-grid
                    system to understand which solution suits your needs.
                </p>
            </div>
            <div class="solar-comparison-wrapper">
                <div class="table-responsive">
                    <table class="solar-comparison-table">
                        <thead>
                            <tr>
                                <th>
                                    Feature
                                </th>
                                <!-- OFF GRID PRIMARY -->
                                <th class="featured-column">
                                    <span class="solar-type off-grid">
                                        Off-Grid Solar
                                    </span>
                                    <small>
                                        Greater energy independence
                                    </small>
                                </th>
                                <th>
                                    <span class="solar-type on-grid">
                                        On-Grid Solar
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Grid Connection -->
                            <tr>
                                <td>
                                    <strong>Grid Connection</strong>
                                </td>
                                <td class="featured-column">
                                    Operates independently without
                                    depending on the electricity grid
                                </td>
                                <td>
                                    Connected to the electricity grid
                                </td>
                            </tr>
                            <!-- Battery -->
                            <tr>
                                <td>
                                    <strong>Battery Storage</strong>
                                </td>
                                <td class="featured-column">
                                    Essential for storing solar energy
                                    for later use
                                </td>
                                <td>
                                    Generally not required
                                </td>
                            </tr>
                            <!-- Power During Outage -->
                            <tr>
                                <td>
                                    <strong>During Grid Outage</strong>
                                </td>
                                <td class="featured-column">
                                    Battery-stored energy can continue
                                    supplying connected loads
                                </td>
                                <td>
                                    Typically does not provide backup
                                    during a grid outage
                                </td>
                            </tr>
                            <!-- Energy Storage -->
                            <tr>
                                <td>
                                    <strong>Energy Storage</strong>
                                </td>
                                <td class="featured-column">
                                    Excess solar energy is stored in
                                    batteries for later use
                                </td>
                                <td>
                                    Usually relies on the grid when
                                    solar generation is insufficient
                                </td>
                            </tr>
                            <!-- Best Suited -->
                            <tr>
                                <td>
                                    <strong>Best Suited For</strong>
                                </td>
                                <td class="featured-column">
                                    Remote locations or areas with
                                    unreliable grid electricity
                                </td>
                                <td>
                                    Homes and businesses with reliable
                                    grid access
                                </td>
                            </tr>
                            <!-- Energy Independence -->
                            <tr>
                                <td>
                                    <strong>Energy Independence</strong>
                                </td>
                                <td class="featured-column">
                                    <span class="status-badge positive">
                                        Higher
                                    </span>
                                </td>
                                <td>
                                    <span class="status-badge neutral">
                                        Lower
                                    </span>
                                </td>
                            </tr>
                            <!-- Key Advantage -->
                            <tr>
                                <td>
                                    <strong>Key Advantage</strong>
                                </td>
                                <td class="featured-column">
                                    <span class="status-badge positive">
                                        Independent Power
                                    </span>
                                </td>
                                <td>
                                    <span class="status-badge neutral">
                                        Grid-Connected Solar
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->

<app-faq></app-faq>